import $ from 'jquery';
$(document).ready(function ($) {
    $('#js-sticky-box__close').click(function(){
        $('#js-sticky-box').addClass('uk-hidden');
    });
});


// WEBPACK FOOTER //
// ./resources/templates/changply/assets/js/components/sticky-box.js